import { useState, useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import api from '@/lib/api';

export default function OriginStoryPage() {
  const { user } = useAuth();
  const [story, setStory] = useState(null);
  const [editing, setEditing] = useState(false);
  const [editContent, setEditContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/legacy/origin-story')
      .then(r => { setStory(r.data); setEditContent(r.data?.content || ''); })
      .finally(() => setLoading(false));
  }, []);

  const handleSave = async () => {
    await api.put('/legacy/origin-story', { title: story?.title || 'Our Story', subtitle: story?.subtitle || '', content: editContent });
    setStory(prev => ({ ...prev, content: editContent }));
    setEditing(false);
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center py-20">
        <div className="w-8 h-8 border-2 border-[#2A7B88] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="max-w-3xl mx-auto fade-in" data-testid="origin-story-page">
      <div className="bg-white rounded-lg border overflow-hidden" style={{ borderColor: '#E5E1DC' }}>
        {/* Header */}
        <div className="px-8 py-10 text-center" style={{ backgroundColor: '#1B2A4A' }}>
          <h1 className="text-3xl font-bold text-white" style={{ fontFamily: 'Georgia, serif' }}>
            {story?.title || 'Our Story'}
          </h1>
          {story?.subtitle && (
            <p className="mt-2 text-sm" style={{ color: '#7C9AB5' }}>{story.subtitle}</p>
          )}
        </div>

        {/* Content */}
        <div className="px-8 py-8">
          {editing ? (
            <div className="space-y-4">
              <textarea
                value={editContent}
                onChange={e => setEditContent(e.target.value)}
                rows={20}
                className="w-full px-4 py-3 rounded-md border text-sm leading-relaxed"
                style={{ borderColor: '#E5E1DC', fontFamily: 'Georgia, serif', color: '#1B2A4A' }}
                data-testid="origin-story-editor"
              />
              <div className="flex gap-2">
                <button onClick={handleSave} className="px-4 py-2 rounded-md text-sm font-medium text-white" style={{ backgroundColor: '#1B2A4A' }}>
                  Save
                </button>
                <button onClick={() => { setEditing(false); setEditContent(story?.content || ''); }}
                  className="px-4 py-2 rounded-md text-sm border" style={{ borderColor: '#E5E1DC' }}>
                  Cancel
                </button>
              </div>
            </div>
          ) : (
            <div>
              <div className="prose max-w-none" style={{ fontFamily: 'Georgia, serif', color: '#1B2A4A', lineHeight: '1.8' }}>
                {story?.content ? (
                  story.content.split('\n').map((paragraph, idx) => (
                    paragraph.trim() ? <p key={idx} className="mb-4 text-sm">{paragraph}</p> : <br key={idx} />
                  ))
                ) : (
                  <p className="text-sm italic" style={{ color: '#9CA3AF' }}>
                    The Origin Story will be added here. This is the story of 30 years of building companies
                    where people stay for 25 years and clients stay for 28 years.
                  </p>
                )}
              </div>

              {user?.role === 'ceo' && (
                <button onClick={() => setEditing(true)}
                  className="mt-6 px-4 py-2 rounded-md text-sm border hover:bg-gray-50"
                  style={{ borderColor: '#E5E1DC', color: '#6B7280' }}
                  data-testid="origin-story-edit-btn">
                  Edit Story
                </button>
              )}
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="px-8 py-6 text-center" style={{ backgroundColor: '#F7F5F2', borderTop: '1px solid #E5E1DC' }}>
          <p className="text-xs italic" style={{ color: '#6B7280', fontFamily: 'Georgia, serif' }}>
            &ldquo;I want to have a system that makes sure Dipali&rsquo;s style lasts beyond Dipali.&rdquo;
          </p>
        </div>
      </div>
    </div>
  );
}
